/**
 * Label mappings — keeps DB values technical (snake_case) but displays
 * proper French labels with accents.
 */
export const STATUS_LABEL = {
  publie: "Publié",
  a_paraitre: "À paraître",
  en_preparation: "En préparation",
};

export const statusLabel = (s) => STATUS_LABEL[s] || s || "";

export const RIGHTS_LABEL = {
  edition_fr: "Édition en langue française",
  etrangers: "Droits étrangers",
  traduction: "Traduction",
  audio: "Livre audio",
  bd: "Bande dessinée",
  cinema: "Cinéma",
  serie: "Série",
  documentaire: "Documentaire",
  adaptation: "Adaptation audiovisuelle",
};

export const rightsLabel = (r) => RIGHTS_LABEL[r] || r || "";

export const NEWS_CATEGORY_LABEL = {
  actualites: "Actualités",
  romans: "Romans",
  ecriture: "Écriture",
  publication: "Publication",
  presse: "Presse",
  evenements: "Événements",
  recherches: "Recherches",
  coulisses: "Coulisses",
  // legacy alias
  parution: "Actualités",
};

export const newsCategoryLabel = (c) => NEWS_CATEGORY_LABEL[c] || c || "";
